import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SmsService {

  constructor(private http: HttpClient) {  
  }

  //54b26f86-837a-426d-abf6-5e001da926df
  //b0ed5b3b-86a9-400b-b1c2-ac4389437650

  sendMessage(user) {
    const username = '54b26f86-837a-426d-abf6-5e001da926df';
    const password = 'b0ed5b3b-86a9-400b-b1c2-ac4389437650';
    const encodedCredentials = btoa(`${username}:${password}`);

    // const body = {
    //   to: '+27722696891',
    //   body: 'Helo'
    // };
   const body = {
      messages: [{
          content: `Hi ${user.firstName}, 
We've received your request to be an RLEAF member.
Your request is being review you will be notifed once you have been approved.`,
          destination: user.contactNumber
      }]
  }

    const headers = new HttpHeaders({
      'Content-Type': 'application/json', 
      'Accept':'*/*',
      // 'Authorization': 'Basic NzE4NzQ3QzI1NzYwNDVFRkE2QzY1MDIwM0QwQzkzMjctMDEtMzo1UXhOcnJYTU9oeWk2QWNuX0lJcHg4Q3hfRkx1bg=='
      'Authorization': `Basic ${encodedCredentials}`
    });
    
    
     const apiUrl = 'https://rest.smsportal.com/bulkmessages';
    
     this.http.post(apiUrl, body, { headers }).subscribe(
      data => {
          console.log('200');
      },
      error => {
          console.error('There was an error!', error);
      }
  );
  }
}
